import React, { useState, useContext, useMemo } from 'react';

import { Button } from '@mui/material';

import SimpleSelect from '../Components/SimpleSelect';
import SimpleTextInput from '../Components/SimpleTextInput';
import KebabInput from '../Components/KebabInput';
import { TransportDocumentsModal } from '../Modals/AdditionalDetailsModals';

import { useStepper } from '../../../components/Stepper';

import { GBENSContext } from '../GBENSContainer';

const AdditionalDetails = () => {
  const [transportDocumentsModalOpen, setTransportDocumentsModalOpen] = useState(false);

  const screen = 'AdditionalDetails';

  const { data, referenceData, handleShowWarningModal, isReadOnly } = useContext(GBENSContext);

  const { gotoStep } = useStepper();

  const onNext = async () => {
    if (isReadOnly) {
      gotoStep('ReviewAndSubmit');
    } else {
      handleShowWarningModal(screen, () => gotoStep('ReviewAndSubmit'));
    }
  };

  const transportDocumentsDisplay = useMemo(() => {
    return data?.[screen]?.TransportDocuments?.rows?.length > 0
      ? data?.[screen]?.TransportDocuments?.rows.map((r) => r.documentReference).join(', ')
      : '';
  }, [data, screen]);

  return (
    <>
      <TransportDocumentsModal
        screen={screen}
        open={transportDocumentsModalOpen}
        setOpen={setTransportDocumentsModalOpen}
      />

      <div style={{ backgroundColor: '#F6F6F6', padding: 30 }}>
        <SimpleTextInput
          name="Seal Number*"
          screen={screen}
          id="sealNumber"
          placeholder="Please add the seal number or use 'NO SEALS'"
          disabled={isReadOnly}
        />

        <KebabInput
          name="Transport Document(s)*"
          value={transportDocumentsDisplay}
          linkText="Add Document"
          placeholder="Click to add"
          screen={screen}
          id="TransportDocuments"
          onClick={() => setTransportDocumentsModalOpen(true)}
          disabled={isReadOnly}
        />

        <SimpleSelect
          name="Transport Charges MOP*"
          screen={screen}
          id="transportCharges"
          options={referenceData.charges}
          disabled={isReadOnly}
        />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingBottom: 30,
          paddingLeft: 30,
          paddingRight: 30,
          paddingTop: 30,
        }}
      >
        <div></div>
        <Button variant="outlined" onClick={onNext}>
          Next: Review
        </Button>
      </div>
    </>
  );
};

export default AdditionalDetails;
